

export const textcolors = {
  primary: "text-[#3885CC]",
  secondary: "text-[#F3F3F5]",
  normaltext: "text-[#1C1C24]",
  success: "text-green-500",
  danger: "text-red-500",
  white: "text-white",
  dark: "text-[#2a2f45]",
  link: "text-[#0088FF]"
};

export const bgcolors = {
  dark: "bg-[#1c1c24]",
  white: "bg-[#ffffff]",
  gray: "bg-[#ECECF0]",
  secondarygray: "bg-[#DDDDDDx]",
  primary: "bg-[#3885CC]",
  secondary: "bg-[#3885CC]",
  body: "bg-[#D9F3FD]",
  inputbg: "bg-[#F3F3F5]",
  componentsclr:"bg-[#2a2f45]"
};

export const textSizes = {
  h1: "text-4xl font-bold",
  h2: "text-3xl font-semibold",
  h3: "text-2xl font-medium",
  title1: "text-lg",
  title2: "text-xl font-bold ",
  subtitle: "text-sm",
  base: "text-base",
  extrasmall: "text-xs",
};

export const bordercolor = {
  borderline: "#C6C6C6"
}

export const fontWeights = {
  thin: "font-thin",
  light: "font-light",
  normal: "font-normal",
  medium: "font-medium",
  semibold: "font-semibold",
  bold: "font-bold",
  extrabold: "font-extrabold",
  black: "font-black",
};

export const buttons = {
  primary: "bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700",
  secondary: "bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600",
  success: "bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600",
  danger: "bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600",
};
